import React, {useContext} from 'react'
import { TextField, Typography, FormControl, FormControlLabel, FormLabel, Radio } from '@mui/material'
import { Trans } from 'react-i18next'
import productTypeIsOneOf from '../../../lib/productTypeIsOneOf'
import { ComplaintTypeOptions, ComplaintTypeState, ProductTypeOptions } from '../../../contexts/types'
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";

type SurfaceOptionsProps = {
    productType: ProductTypeOptions
    selectedOption: ComplaintTypeOptions
    handleTextFieldChange: (fieldName: keyof ComplaintTypeState, value: string) => void
    surfaceDefectExplanation: string | undefined
    surfaceDefectExplanationError: string | undefined
}

const SurfaceOptions: React.FC<SurfaceOptionsProps> = 
    ({ handleTextFieldChange, productType, selectedOption, surfaceDefectExplanation, surfaceDefectExplanationError }) => {
        const { t, tns } = useContext(OrgCustomizationContext)
        const handleChange = (
            e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
        ) => {
            handleTextFieldChange('surfaceDefectExplanation', e.target.value)
        }

        return (
            <>
                {/* Surface */}
                <Typography
                    variant='body1'
                    color='secondary.contrastText'
                    sx={{ pt: 2 }}
                >
                    <Trans i18nKey={tns('cti_complaint_surface')}>
                        -
                        <Typography component='span' sx={{ color: 'primary.main' }}>
                            -
                        </Typography>
                        -
                    </Trans>
                </Typography>
                
                
                <FormControlLabel
                    value='DISCOLORATION'
                    control={<Radio />}
                    label={t('cti_option_discoloration') as string}
                />
               
                <FormControlLabel
                    value='SURFACE_CORRODED'
                    control={<Radio />}
                    label={t('cti_option_surface_corroded') as string}
                />
                <FormControlLabel
                    value='COATING_FLAKING_OFF'
                    control={<Radio />}
                    label={t('cti_option_coating_flaking_off') as string}
                />

                {productTypeIsOneOf(
                    [
                        'ABUTMENT',
                        'SCREW',
                        'CLINICAL_INSTRUMENT',
                        'LAB_INSTRUMENT_LAB_SCREW',
                    ],
                    productType
                ) && (
                    <FormControlLabel
                        value='INTERFACE_FRETTING'
                        control={<Radio />}
                        label={t('cti_option_interface_fretting') as string}
                    />
                )}
                 <FormControlLabel
                    value='SURFACE_DEFECT'
                    control={<Radio />}
                    label={t('cti_option_surface_defect') as string}
                />
                {selectedOption === 'SURFACE_DEFECT' && (
                    <FormControl sx={{ pt: 0 }}>
                        <FormLabel sx={{ mb: 1 }}>
                            {t('cti_please_explain')}:
                        </FormLabel>
                        <TextField
                            multiline
                            minRows={2}
                            maxRows={4}
                            sx={{ maxWidth: '40rem', mb: 2 }}
                            error={!!surfaceDefectExplanationError}
                            helperText={surfaceDefectExplanationError}
                            value={surfaceDefectExplanation}
                            onChange={handleChange}
                        />
                    </FormControl>
                )}
            </>
        )
}

export default SurfaceOptions
